export default "__VITE_ASSET__DMhmbX4U__"